<script setup lang="ts">
import { RouterView } from 'vue-router'
import { scanRevision } from '@/check-in/ticket'
import RouteJourney from '@/components/visual/RouteJourney.vue'
import RoutePage from '@/components/visual/RoutePage.vue'
import { portal, leavePortalPage } from '@/motion/page-portal'
</script>

<template>
  <div
    id="route-portal"
    data-flip-id="route-portal"
    :class="['route-portal', { 'is-open': portal.open }]"
  >
    <div class="portal-grain" aria-hidden="true" />
    <span class="portal-seed-label" aria-hidden="true">{{ portal.label }}</span>
    <div id="route-portal-content" class="portal-content" />
  </div>
  <div
    class="route-host"
    :style="{ minHeight: portal.lifted ? `${portal.height}px` : undefined }"
  >
    <RouterView v-slot="{ Component, route }">
      <Transition :css="false" @leave="leavePortalPage">
        <RoutePage
          :key="route.path === '/check-in' ? `${route.path}:${scanRevision}` : route.path"
          :component="Component"
          :path="route.path"
        />
      </Transition>
    </RouterView>
  </div>
  <RouteJourney />
</template>
